(function($) {

    $.fn.coverselector = function (options) {

        var $elem = this;
        var settings = $.extend({}, options);

        $elem.find('.cover-template').click(function(e) {
            e.preventDefault();
            $elem.find('.cover-template').removeClass('selected');
            $(this).addClass('selected');

            $elem.find('.cover-selector-button').prop('disabled', false);
        });


        $elem.find('.cover-selector-button').click(function() {
            window.location = $elem.find('.cover-template.selected > a').attr('href');
        });

    };

}( jQuery ));